// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"854":"577a2cb6","3199":"577a2cb6","4987":"577a2cb6","8010":"577a2cb6","9036":"9d0db338"}[chunkId] + ".chunk.css";
};